import { QueryClient } from '@tanstack/react-query';
import { produce } from 'immer';

import type { ApiQuerySuccessPromise } from '@/types';
import type { RiskFreePromoInfo } from '../types';
import { riskFreePromoKeys } from '../hooks/keys';

/**
 * Update RiskFreePromoInfo optimistically.
 * 
 * ⚠ Notice: You must ensure that the data is saved to the database!
 * @param queryClient - The instance of QueryClient of React Query
 */
const updateUsedFreeVouchersToMax = (queryClient: QueryClient) => {
	queryClient.cancelQueries(riskFreePromoKeys.all);
	queryClient.setQueryData<ApiQuerySuccessPromise<RiskFreePromoInfo> | undefined>(riskFreePromoKeys.all, old => {
		return produce(old, draft => {
			if (draft?.data.Data && draft.data.Data.QuantitySold < draft.data.Data.LimitPerPeriod) {
				draft.data.Data.QuantitySold = draft.data.Data.LimitPerPeriod;
			}
		});
	});
};

export const riskFreePromoService = {
	updateUsedFreeVouchersToMax
};